module.exports = __webpack_public_path__ + "img/aliens-texture.a0bae413.png";